import "../../../src/style/visualsearchdemo.scss";
import "../../../src/style/common/divider.scss";

function AiStylist (){
    return (
        <div className="columns highlight-info">
            <div className="column col-lg-12 col-6 highlight-content-left last-lg">
                <div className="content-wrap image-block">
                    <img className="vs-img" src="./images/aiStylist.png" alt="Ai stylist"></img>
                </div>
            </div>
            <div className="column col-lg-12 col-6">
                <div className="content-wrap">
                    <div className="mb-1 title">AI Stylist</div>
                    <div className="divider"></div>
                    <div className="feature-description desc col-xl-12 col-12">
                        Our AI has learnt from millions of products to identify “looks” and can recommend products that suit best to “Complete the look”. Automate and part ways with the need to sit in multiple hours to curate looks manually
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default AiStylist;